import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  MARKETING_FETCH,
  UPDATE_FEATURE,
  UPDATE_FEATURE_MASCOT,
  UPDATE_AGENT_MASCOT,
  M_POST,
  M_GET, UPDATE_FEATURE_ANGPOW,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'marketing' })
export default class Marketing extends VuexModule {
  @Action
  async Fetch() {
    return Vue.axios({
      url: BASE_URL + MARKETING_FETCH,
      data: '',
      method: M_GET,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  async FeatureUpdate(params) {
    return Vue.axios({
      url: BASE_URL + UPDATE_FEATURE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  async FeatureMascotUpdate(params) {
    return Vue.axios({
      url: BASE_URL + UPDATE_FEATURE_MASCOT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  async AgentMascotUpdate(params) {
    return Vue.axios({
      url: BASE_URL + UPDATE_AGENT_MASCOT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  async FeatureAngpowUpdate(params) {
    return Vue.axios({
      url: BASE_URL + UPDATE_FEATURE_ANGPOW,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }
}
